import React from 'react';
import {triggerEdapButtonClick, eventCategories} from '../../util/edap';

const QualificationSection = () => {
    return (
        <>
            <div className="cpp-page__content__qualification">
                <h2 className="section-heading">How to qualify</h2>
                <p>
                    Connectivity partners can secure Elite or Preferred status
                    for 2027 by reaching specific goals and business and
                    technical metrics under the categories listed.
                    <sup>3</sup>
                </p>
                <div className="cpp-page__content__qualification-details">
                    <div className="section-heading">Qualifying metrics</div>
                    <table className="table table-responsive">
                        <tbody>
                            <tr>
                                <th>
                                    <strong>Category</strong>
                                </th>
                                <th>
                                    <strong>Metric</strong>
                                </th>
                            </tr>
                            <tr>
                                <td>Production / Growth</td>
                                <td>
                                    <p>
                                        Connected Properties Net Room Nights
                                        (booked)*, Connected Properties Net Room
                                        Nights (booked) Growth (YoY)*, Offer
                                        Strength
                                    </p>
                                    <p>
                                        <i>
                                            * Eligibility criteria apply to
                                            participate in this metric. Please
                                            consult your account manager for
                                            more details.
                                        </i>
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td>Partner engagement quality </td>
                                <td>
                                    Based on Expedia Voices participation,
                                    survey participation, leadership and tech
                                    engagement, innovation, signing letter of
                                    intent in adopting the Autonomous Supply
                                    suite and overall partnership with Expedia
                                    Group
                                </td>
                            </tr>
                            <tr>
                                <td>Connection experience</td>
                                <td>
                                    Capability adoption and Capability Success
                                    Rates
                                </td>
                            </tr>
                            <tr>
                                <td>Commercial &amp; Technical</td>
                                <td>Optimization Initiatives</td>
                            </tr>
                        </tbody>
                    </table>
                    <div className="cpp-minimum-requirements-wrapper">
                        <div className="section-heading">
                            2026/27 Connectivity Partner Program minimum
                            requirements
                        </div>
                        <p>
                            System type requirements: Property Distribution
                            Software
                            <sup>4</sup>
                        </p>
                        <p>
                            Technical requirements: Availability/Rates API with
                            support for Expedia Traveler Preference (ETP),
                            Booking Retrieval/ Notification API with support for
                            virtual cards and Value Add Promotions (VAP), PCI
                            compliance (where applicable)
                        </p>
                        <p>
                            Commercial requirements: Expedia Group API License
                            Agreement acceptance.
                        </p>
                    </div>
                    <div className="cpp-timeline-wrapper">
                        <div className="section-heading">Timeline</div>
                        <p>
                            The Connectivity Partner Program will operate on an
                            annual basis:
                        </p>
                        <ul className="timeline-list">
                            <li>September 2025: Program criteria announced</li>
                            <li>
                                January 1 - December 31, 2026: Program
                                qualification measurement period
                            </li>
                            <li>
                                September 30, 2026: Deadline to submit
                                capability adoption certification requests
                            </li>
                            <li>
                                November 27, 2026: Deadline for successful
                                certification completion
                            </li>
                            <li>
                                December 11, 2026: Deadline for successful
                                optimization initiative completion for credit
                            </li>

                            <li>
                                Q1 2027 - Elite and Preferred partners announced
                                for 2027 program
                            </li>
                        </ul>
                    </div>
                    <p className="current-cpp-list">
                        <a
                            onClick={triggerEdapButtonClick(
                                eventCategories.CONTENT_LINKS,
                                'Current Connectivity Partner list'
                            )}
                            href="https://www.expediapartnercentral.com/connectivity"
                        >
                            See the current list of Elite and Preferred
                            Connectivity Partners
                        </a>
                    </p>
                </div>
            </div>
        </>
    );
};

export default QualificationSection;
